module.exports = __webpack_public_path__ + "img/section9-2.e9932c02.svg";